import * as React from 'react';
import {HomePageContent} from "src/pages/HomePageContent/HomePageContent";

export function ProductListing() {
    return (
        <>
            <HomePageContent/>
        </>
    );
}
